import { __exports as UPC } from "./index196.js";
import { __require as requireEncoder } from "./index194.js";
import { __require as requireBarcode } from "./index158.js";
var hasRequiredUPC;
function requireUPC() {
  if (hasRequiredUPC) return UPC;
  hasRequiredUPC = 1;
  Object.defineProperty(UPC, "__esModule", {
    value: true
  });
  var _createClass = /* @__PURE__ */ (function() {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function(Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  })();
  UPC.checksum = checksum;
  var _encoder = requireEncoder();
  var _encoder2 = _interopRequireDefault(_encoder);
  var _Barcode2 = requireBarcode();
  var _Barcode3 = _interopRequireDefault(_Barcode2);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var UPC$1 = (function(_Barcode) {
    _inherits(UPC2, _Barcode);
    function UPC2(data, options) {
      _classCallCheck(this, UPC2);
      if (data.search(/^[0-9]{11}$/) !== -1) {
        data += checksum(data);
      }
      var _this = _possibleConstructorReturn(this, (UPC2.__proto__ || Object.getPrototypeOf(UPC2)).call(this, data, options));
      _this.displayValue = options.displayValue;
      if (options.fontSize > options.width * 10) {
        _this.fontSize = options.width * 10;
      } else {
        _this.fontSize = options.fontSize;
      }
      _this.guardHeight = options.height + _this.fontSize / 2 + options.textMargin;
      return _this;
    }
    _createClass(UPC2, [{
      key: "valid",
      value: function valid() {
        return this.data.search(/^[0-9]{12}$/) !== -1 && this.data[11] == checksum(this.data);
      }
    }, {
      key: "encode",
      value: function encode() {
        if (this.options.flat) {
          return this.flatEncoding();
        } else {
          return this.guardedEncoding();
        }
      }
    }, {
      key: "flatEncoding",
      value: function flatEncoding() {
        var result = "";
        result += "101";
        result += (0, _encoder2.default)(this.data.substr(0, 6), "LLLLLL");
        result += "01010";
        result += (0, _encoder2.default)(this.data.substr(6, 6), "RRRRRR");
        result += "101";
        return {
          data: result,
          text: this.text
        };
      }
    }, {
      key: "guardedEncoding",
      value: function guardedEncoding() {
        var result = [];
        if (this.displayValue) {
          result.push({
            data: "00000000",
            text: this.text.substr(0, 1),
            options: { textAlign: "left", fontSize: this.fontSize }
          });
        }
        result.push({
          data: "101" + (0, _encoder2.default)(this.data[0], "L"),
          options: { height: this.guardHeight }
        });
        result.push({
          data: (0, _encoder2.default)(this.data.substr(1, 5), "LLLLL"),
          text: this.text.substr(1, 5),
          options: { fontSize: this.fontSize }
        });
        result.push({
          data: "01010",
          options: { height: this.guardHeight }
        });
        result.push({
          data: (0, _encoder2.default)(this.data.substr(6, 5), "RRRRR"),
          text: this.text.substr(6, 5),
          options: { fontSize: this.fontSize }
        });
        result.push({
          data: (0, _encoder2.default)(this.data[11], "R") + "101",
          options: { height: this.guardHeight }
        });
        if (this.displayValue) {
          result.push({
            data: "00000000",
            text: this.text.substr(11, 1),
            options: { textAlign: "right", fontSize: this.fontSize }
          });
        }
        return result;
      }
    }]);
    return UPC2;
  })(_Barcode3.default);
  function checksum(number) {
    var result = 0;
    var i;
    for (i = 1; i < 11; i += 2) {
      result += parseInt(number[i]);
    }
    for (i = 0; i < 11; i += 2) {
      result += parseInt(number[i]) * 3;
    }
    return (10 - result % 10) % 10;
  }
  UPC.default = UPC$1;
  return UPC;
}
export {
  requireUPC as __require
};
//# sourceMappingURL=index169.js.map
